import type { SvgProps } from "components/icons/types";

// fi-rs-check — bare rounded checkmark (no circle); natural ~12x8 aspect.
export const FiCheck = (props: SvgProps) => (
  <svg
    width="12"
    height="8"
    viewBox="0 0 11.914 8.142"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.857 8.142C3.66006 8.14236 3.46499 8.10381 3.283 8.02856C3.10101 7.95331 2.93567 7.84284 2.7965 7.7035L0 4.9075L0.707 4.2L3.5035 6.9965C3.59726 7.09024 3.72442 7.14289 3.857 7.14289C3.98958 7.14289 4.11674 7.09024 4.2105 6.9965L11.207 0L11.914 0.707L4.9175 7.7035C4.77833 7.84284 4.61299 7.95331 4.431 8.02856C4.24901 8.10381 4.05394 8.14236 3.857 8.142Z"
      fill="currentColor"
    />
  </svg>
);
